import { BaseMarquee } from "../../component/marquee";
import { Cart } from "../../container/cart";
import { Footer } from "../../container/footer";
import { Location } from "../../container/location";
import { Navigation } from "../../container/navigation";
import { CheckoutWrapper } from "./styled";

export const Checkout = () => {
	return (
		<CheckoutWrapper
			maxWidth={false}
			sx={{
				padding: "0 !important",
			}}
		>
			<BaseMarquee
				items={[<Location />]}
				background="var(--marquee-bg-color)"
			/>
			<Navigation />
			<Cart />
			<Footer />
		</CheckoutWrapper>
	);
};
